const currency = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '-';
  const normalized = Object.is(amount, -0) ? 0 : amount;
  return currency.format(normalized);
};

export const formatNumber = (value) => {
  if (value === null || value === undefined) return '-';
  return new Intl.NumberFormat('en-US').format(value);
};

export const formatDateTime = (value) => {
  if (!value) return '-';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString();
};

/**
 * The order number and customer details are copied onto the usage log at the
 * time of the sale. Usages recorded before that started have neither; they
 * read as blank, never as the underlying uuid.
 */
export const formatOrder = (row) => row.orderNumber || '-';

/** Channels that number an order only once fall back to that one number. */
export const formatDisplayNumber = (row) =>
  row.displayNumber || row.orderNumber || '-';

export const customerName = (row) =>
  [row.customerInfo?.firstName, row.customerInfo?.lastName]
    .filter(Boolean)
    .join(' ')
    .trim();

export const customerPhone = (row) => row.customerInfo?.phoneNumber || '';

/** POS enums reach the UI as SCREAMING_SNAKE_CASE. */
export const formatEnum = (value) => {
  if (!value) return '-';
  return value
    .toString()
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
